var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeaser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avatar/users/leaser") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 64.3169 50 64.3169 50 -0.0001 0 -0.0001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avatar/users/leaser",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-49",
    transform: "translate(15.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.959,33.9351 C20.849,33.9351 16.853,34.4131 13,35.2781 L13,41.3171 L37,41.3171 L37,35.2961 C33.123,34.4191 29.1,33.9351 24.959,33.9351",
    id: "Fill-1",
    fill: "#93E080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,35.2781 L13,41.3171 L37,41.3171 L37,35.2961 C33.123,34.4191 29.1,33.9351 24.959,33.9351 C20.849,33.9351 16.853,34.4131 13,35.2781 Z",
    id: "Fill-3",
    fillOpacity: 0.2,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,37.8462 L32,31.3172 L18,31.3172 L18,37.8352 C16.984,37.9642 15.976,38.1122 14.979,38.2952 L25,48.3172 L35.009,38.3082 C34.016,38.1242 33.011,37.9762 32,37.8462",
    id: "Fill-5",
    fill: "#C28F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9785,38.2949 L16.0295,39.3459 C16.6455,39.4819 17.3015,39.5919 17.9995,39.6559 C22.4555,40.0629 28.0625,39.5669 31.9995,36.5669 L31.9995,31.3789 L17.9995,32.3169 L17.9995,37.8359 C16.9845,37.9639 15.9755,38.1119 14.9785,38.2949",
    id: "Fill-7",
    fill: "#966F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,47.3169 L13.021,35.2959 L8.632,38.8609 C5.639,39.7919 2.752,40.9649 0,42.3659 L0,60.3169 L50,60.3169 L50,42.4069 C47.263,41.0079 44.391,39.8359 41.414,38.9029 L41.417,38.8999 L36.979,35.2959 L25,47.3169 Z",
    id: "Fill-9",
    fill: "#53AD58"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(8.000000, 34.316900)",
    fill: "#93E080"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    points: "21 17 33.417 4.583 29 1 17 13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    points: "13 17 0.583 4.583 5.021 0.979 17 13"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25,47.3169 L13.021,35.2959 L8.632,38.8609 C5.639,39.7919 2.752,40.9649 0,42.3659 L0,60.3169 L25,60.3169 L25,47.3169 Z",
    id: "Fill-11",
    fillOpacity: 0.2,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,13.3169 L12,21.3799 L38,21.3799 L38,13.4249 C38,7.0319 33.552,1.3329 27.26,0.2069 C19.017,-1.2681 12.001,5.3589 12,13.3169",
    id: "Fill-18",
    fill: "#E8D392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,25.3169 L14,25.3169 C12.896,25.3169 12,24.4209 12,23.3169 L12,20.3169 C12,19.2129 12.896,18.3169 14,18.3169 L36,18.3169 C37.104,18.3169 38,19.2129 38,20.3169 L38,23.3169 C38,24.4209 37.104,25.3169 36,25.3169",
    id: "Fill-20",
    fill: "#966F4D"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-22",
    fill: "#E8D392",
    points: "11.958 13.0435 11.958 13.0455 11.96 13.0455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.958,24.3169 C35.958,30.3919 31.033,35.3169 24.958,35.3169 C18.883,35.3169 14,30.3919 14,24.3169 L14,14.7169 C14,8.6419 18.883,3.7169 24.958,3.7169 C31.033,3.7169 35.958,8.6419 35.958,14.7169 L35.958,24.3169 Z",
    id: "Fill-24",
    fill: "#C28F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,15.7856 C22.182,15.1606 21.152,14.7856 20.031,14.7856 C18.91,14.7856 17.881,15.1606 17.063,15.7856",
    id: "Stroke-26",
    stroke: "#E8D392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,15.7856 C32.182,15.1606 31.152,14.7856 30.031,14.7856 C28.91,14.7856 27.881,15.1606 27.063,15.7856",
    id: "Stroke-28",
    stroke: "#E8D392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,7.1919 C19.375,12.6289 25.937,16.6919 35.958,14.7169 L35.958,11.4419 L18,7.1919 Z",
    id: "Fill-30",
    fillOpacity: 0.2,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,13.3159 L36.208,9.8169 C34.625,5.6579 29.673,2.2739 24.958,2.2739 C18.86,2.2739 13.959,5.9699 13.959,12.0669 C13.959,12.0669 13.958,16.0289 13.958,17.5039 C13.958,12.7539 15.375,9.3169 18,7.1919 C19.875,12.5669 30,15.3159 35.998,13.3159 L36,13.3159 Z",
    id: "Fill-32",
    fill: "#E8D392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,16.3169 L37,16.3169",
    id: "Fill-34",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.625,27.3301 C22.492,28.0551 23.642,28.5941 25,28.5941 C26.358,28.5941 27.578,28.0321 28.375,27.3301",
    id: "Stroke-36",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-38",
    fillOpacity: 0.2,
    fill: "#000000",
    points: "16 60.3169 42 60.3169 42 50.3169 16 50.3169"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-40",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "20 64.3169 46 64.3169 46 45.3169 20 45.3169"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-42",
    fill: "#777A80",
    mask: "url(#mask-2)",
    points: "24 51.3169 42 51.3169 42 49.3169 24 49.3169"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-43",
    fill: "#C8C8C8",
    mask: "url(#mask-2)",
    points: "30 56.3169 42 56.3169 42 54.3169 30 54.3169"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-44",
    fill: "#C8C8C8",
    mask: "url(#mask-2)",
    points: "30 61.3169 42 61.3169 42 59.3169 30 59.3169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,55.3169 C28,56.4209 27.104,57.3169 26,57.3169 C24.896,57.3169 24,56.4209 24,55.3169 C24,54.2129 24.896,53.3169 26,53.3169 C27.104,53.3169 28,54.2129 28,55.3169",
    id: "Fill-45",
    fill: "#53AD58",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,60.3169 C28,61.4209 27.104,62.3169 26,62.3169 C24.896,62.3169 24,61.4209 24,60.3169 C24,59.2129 24.896,58.3169 26,58.3169 C27.104,58.3169 28,59.2129 28,60.3169",
    id: "Fill-46",
    fill: "#53AD58",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,17.3169 C21,17.8689 20.553,18.3169 20,18.3169 C19.447,18.3169 19,17.8689 19,17.3169 C19,16.7649 19.447,16.3169 20,16.3169 C20.553,16.3169 21,16.7649 21,17.3169",
    id: "Fill-47",
    fill: "#000000",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,17.3169 C31,17.8689 30.553,18.3169 30,18.3169 C29.447,18.3169 29,17.8689 29,17.3169 C29,16.7649 29.447,16.3169 30,16.3169 C30.553,16.3169 31,16.7649 31,17.3169",
    id: "Fill-48",
    fill: "#000000",
    mask: "url(#mask-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaser);
export default __webpack_public_path__ + "static/media/leaser.b475c39ad9e92e0aae132924d6fbc967.svg";
export { ForwardRef as ReactComponent };